import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LucideAngularModule } from 'lucide-angular';
import { decodeSurveyEmoji } from './survey-promoter';

@Component({
  selector: 'app-survey-play-store-prompt',
  imports: [ButtonModule, LucideAngularModule],
  templateUrl: './survey-play-store-prompt.component.html',
  styleUrl: './survey-play-store-prompt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyPlayStorePromptComponent {
  googleReviewSentence = input<string>('');
  emoji = input<string>('');
  googleLink = input<string | null | undefined>(null);

  closeModal = output<void>();
  reviewLinkClicked = output<void>();

  readonly decodedEmoji = computed(() => decodeSurveyEmoji(this.emoji()));

  readonly showGoogleCta = computed(() => {
    const link = this.googleLink();
    return typeof link === 'string' && link.length > 0;
  });

  close(): void {
    this.closeModal.emit();
  }

  openGoogleReview(): void {
    if (!this.showGoogleCta()) {
      return;
    }

    this.reviewLinkClicked.emit();
  }
}
